module.exports = __webpack_public_path__ + "media/images/athletes/1347-17a1abb1a6ad72a3b775ecfbebb76d08.png";